// extracted by mini-css-extract-plugin
export var changeIcon = "_5z-4";
export var container = "_5z-0";
export var divider = "_5z-7";
export var externalLinkIcon = "_5z-1";
export var green = "_5z-5";
export var helpCircleIcon = "_5z-3";
export var iconButton = "_5z-2";
export var red = "_5z-6";